import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { TimeIsFlyingPopup } from './TimeIsFlyingPopup';
import uuid from 'uuid-random';

const timeIsFlyingId = uuid();

export const showTimeIsFlyingPopupAction = ({ disableNotification, onClose } = {}) => addPopupAction({
    id: timeIsFlyingId,
    component: TimeIsFlyingPopup,
    layer: LAYER.TIME_IS_FLYING,
    data: { disableNotification, onClose }
});
